import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { PDFDocument } from 'pdf-lib'
import { FileHelper } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-activities-rw',
  templateUrl: './page-activities-rw.component.html',
  styleUrls: ['./page-activities-rw.component.css', '../module-page-rw/module-page-rw.component.css']
})
export class PageActivitiesRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  buttons = 5;

  content = {
    downloaded: this.generate(this.buttons, false),
    validate:   false,
  };

  pdfHandoutFillable1!: PDFDocument;
  pdfKey1!: PDFDocument;

  pdfHandoutFillable2!: PDFDocument;
  pdfKey2!: PDFDocument;

  pdfHandoutFillable4!: PDFDocument;

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  async ngOnInit(): Promise<void> {
    const handoutFillablePdfBytes1 = await fetch("../../../../../assets/RWM2A1HandoutFillable.pdf").then(res => res.arrayBuffer());
    this.pdfHandoutFillable1 = await PDFDocument.load(handoutFillablePdfBytes1);
    const keyPdfBytes1 = await fetch("../../../../../assets/RWM2A1Key.pdf").then(res => res.arrayBuffer());
    this.pdfKey1 = await PDFDocument.load(keyPdfBytes1);

    const handoutFillablePdfBytes2 = await fetch("../../../../../assets/RWM2A2HandoutFillable.pdf").then(res => res.arrayBuffer());
    this.pdfHandoutFillable2 = await PDFDocument.load(handoutFillablePdfBytes2);
    const keyPdfBytes2 = await fetch("../../../../../assets/RWM2A2Key.pdf").then(res => res.arrayBuffer());
    this.pdfKey2 = await PDFDocument.load(keyPdfBytes2);

    const handoutFillablePdfBytes4 = await fetch("../../../../../assets/RWM2A4Handout.pdf").then(res => res.arrayBuffer());
    this.pdfHandoutFillable4 = await PDFDocument.load(handoutFillablePdfBytes4);
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  private generate(count: number, value: boolean) {
    const array = _.range(count);
    const object = _(array).map(i => [i, value]).fromPairs().value() as Indexable<boolean>;
    return object;
  }

  async downloadHandoutFillablePdf1 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandoutFillable1.save();
    FileHelper.saveByteArray('RWM2A1HandoutFillable.pdf', pdfBytes, 'application/pdf');
  }

  async downloadKeyPdf1 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfKey1.save();
    FileHelper.saveByteArray('RWM2A1Key.pdf', pdfBytes, 'application/pdf');
  }

  async downloadHandoutFillablePdf2 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandoutFillable2.save();
    FileHelper.saveByteArray('RWM2A2HandoutFillable.pdf', pdfBytes, 'application/pdf');
  }

  async downloadKeyPdf2 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfKey2.save();
    FileHelper.saveByteArray('RWM2A2Key.pdf', pdfBytes, 'application/pdf');
  }

  async downloadHandoutFillablePdf4 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandoutFillable4.save();
    FileHelper.saveByteArray('RWM2A4HandoutFillable.pdf', pdfBytes, 'application/pdf');
  }

  all<T = unknown>(array: T[], value: T) {
    return array.every(v => v === value);
  }

  allOf(obj: Object, value = true) {
    return this.all(Object.values(obj), value);
  }
}
